import { ArrowTurnUpLeftIcon } from "@heroicons/react/24/outline";
import { parseHyphenatedText } from "@utils/utils";

import { DropdownMenuItem } from "@fronterahealth/frontera-ui-components/ui/dropdown-menu";

import {
  MoveSectionActionEnum,
  ReportSectionsType,
  useMoveSectionToOrFromAppendixMutation,
} from "@api/graphql/types-and-hooks";
import { notifyError } from "@components/notifications/notifications";
import { useReport } from "@providers/ReportProvider";

interface Props {
  section: ReportSectionsType;
}

export const ReportSectionActionMenuReturnFromAppendix: React.FC<Props> = ({ section }) => {
  const { reportQuery } = useReport();
  const { mutate: moveSectionMutate } = useMoveSectionToOrFromAppendixMutation({
    onSuccess: async (data) => {
      if (data.moveReportSection?.status) {
        await reportQuery.refetch();
      } else if (data.moveReportSection?.status === false) {
        notifyError(data.moveReportSection?.message ?? "Error Moving Section from Appendix");
      }
    },
    onError: (error) => {
      console.error("Error moving section from appendix:", error);
      notifyError("Error Moving Section from Appendix");
    },
  });

  return (
    <DropdownMenuItem
      onClick={() =>
        moveSectionMutate({ input: { reportSectionId: section.id, action: MoveSectionActionEnum.MoveBack } })
      }
    >
      <ArrowTurnUpLeftIcon />
      Return to {parseHyphenatedText(section.previousPageLocation ?? "")}
    </DropdownMenuItem>
  );
};
